import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-no-show-summary',
  templateUrl: './no-show-summary.component.html',
  styleUrls: ['./no-show-summary.component.scss']
})
export class NoShowSummaryComponent {
  @Input() noshow: any;
  @Input() viewMode: 'user' | 'admin' | 'ota';
  @Input() currency: string;
  @Input() exchangeRate: number | undefined;

  constructor(){}
  ngOnInit() {} 

  formatCurrency = (price: number, currency: string) => {
    const validPrice = typeof price === 'number' && !isNaN(price);
    const validRate = typeof this.exchangeRate === 'number' && !isNaN(this.exchangeRate);
  
    const finalPrice = validPrice && validRate ? price * (this.exchangeRate || 1) : 0;
  
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency,
    }).format(finalPrice);
  };
}
